import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Background from "../../assets/coilKuning.jpeg";
import FotoHeader from "../../assets/coilAbuProducts.jpeg";

const Aplikasi = () => {
  const navigate = useNavigate();

  const BgHeader = {
    backgroundImage: `url(${FotoHeader})`,
    backgroundSize: "cover",
    backgroundPosition: "40% 60%",
    overflow: "hidden",
  };

  const handleJobClick = (jobPath) => {
    navigate(jobPath);
  };

  return (
    <>
      {/* APLIKASI PC */}
      <section className="hidden sm:block">
        <h1 className="text-4xl container-screen text-primaryPandawa font-helvetica text-left">
          Lowongan Tersedia
        </h1>
        <section className="container-screen grid grid-cols-5 py-10">
          <div className="col-span-3">
            <div>
              <div className="text-left">
                <div
                  className="bg-black px-4 py-1 rounded-full text-white w-auto inline-block cursor-pointer   transition-all duration-300 transform  hover:shadow-lg group"
                  onClick={() => handleJobClick("/team-surat-jalan")}
                >
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold ">
                      1. Team Surat Jalan
                    </h2>
                    <FiArrowRight className="text-white text-lg transform group-hover:translate-x-1 transition-transform duration-300 " />
                  </div>
                </div>
              </div>
              <p className="text-justify mt-2">
                Secara proaktif terlibat dalam aktivitas penjualan, termasuk
                mengidentifikasi dan mendapatkan peluang bisnis baru serta calon
                klien.
              </p>
              <div className="mt-4">
                <h3 className="font-helvetica font-semibold text-gray-800 mb-2 text-left">
                  Kualifikasi:
                </h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4 text-left">
                  <li className="font-montserrat">
                    Pendidikan minimal D3 dari jurusan yang relevan
                  </li>
                  <li className="font-montserrat">Usia 22-40 tahun</li>
                </ul>
              </div>
              <div className="text-left mt-12">
                <div
                  className="bg-black px-4 py-1 rounded-full w-auto inline-block cursor-pointer transition-all duration-300 transform hover:shadow-lg group"
                  onClick={() => handleJobClick("/stock-administrator")}
                >
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold text-white">
                      2. Stock Administrator
                    </h2>
                    <FiArrowRight className="text-white text-lg transform group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </div>
              <p className="text-justify mt-2">
                Bertanggung jawab untuk mengelola dan memantau inventarisasi
                gudang, memastikan akurasi stok, mengembangkan SOP warehouse,
                dan melakukan koordinasi dengan tim terkait untuk menjaga
                ketersediaan barang serta membuat laporan pergerakan stok secara
                berkala.
              </p>
              <div className="mt-4">
                <h3 className="font-helvetica font-semibold text-gray-800 mb-2 text-left">
                  Kualifikasi:
                </h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4 text-left">
                  <li className="font-montserrat">
                    Pendidikan minimal D3 dari jurusan yang relevan
                  </li>

                  <li className="font-montserrat">Usia 22-40 tahun</li>
                </ul>
              </div>
              <div className="text-left mt-12">
                <div
                  className="bg-black px-4 py-1 rounded-full w-auto inline-block cursor-pointer transition-all duration-300 transform hover:shadow-lg group"
                  onClick={() => handleJobClick("/sales-person")}
                >
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold text-white">
                      3. Sales Person
                    </h2>
                    <FiArrowRight className="text-white text-lg transform group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </div>
              <p className="text-justify mt-2">
                Bertanggung jawab dalam mencari dan membina hubungan dengan
                pelanggan baru maupun existing, menawarkan produk sesuai
                kebutuhan klien, menyusun penawaran, serta memastikan proses
                penjualan hingga pengiriman berjalan lancar.
              </p>
              <div className="mt-4">
                <h3 className="font-helvetica font-semibold text-gray-800 mb-2 text-left">
                  Kualifikasi:
                </h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4 text-left">
                  <li className="font-montserrat">
                    Minimal lulusan SMA/SMK/ D3/S1
                  </li>

                  <li className="font-montserrat">
                    Memiliki SIM A/C dan bersedia melakukan kunjungan lapangan
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-2 rounded-lg overflow-hidden ml-auto h-full w-1/2">
            <img
              src={Background}
              alt="Background"
              className="h-full w-auto object-cover"
            />
          </div>
        </section>
      </section>

      {/* MOBILE VERSION */}
      <section className="sm:hidden" style={BgHeader}>
        <div className="bg-primaryPandawa/90 py-8">
          <div className="container-screen">
            <h1 className="font-helvetica text-white tracking-widest text-left text-2xl mb-10">
              Lowongan Tersedia
            </h1>
            <div className="text-left text-white space-y-8">
              {/* Sales Person Mobile */}
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <div
                  className="flex items-center justify-between cursor-pointer hover:bg-white/10 transition-all duration-300 group p-2 rounded-lg -m-2"
                  onClick={() => handleJobClick("/team-surat-jalan")}
                >
                  <h2 className="font-helvetica tracking-wider text-white font-bold text-lg">
                    1. Team Surat Jalan
                  </h2>
                  <p className="text-white bg-black px-4 rounded-lg py-2 text-sm  transform group-hover:translate-x-1 transition-transform duration-300">
                    Lamar
                  </p>
                </div>
                <p className="font-montserrat text-white/90 text-justify mt-4 leading-relaxed">
                  Secara proaktif terlibat dalam aktivitas penjualan, termasuk
                  mengidentifikasi dan mendapatkan peluang bisnis baru serta
                  calon klien.
                </p>
                <div className="mt-4">
                  <h3 className="font-helvetica font-semibold text-white mb-2">
                    Kualifikasi:
                  </h3>
                  <ul className="list-disc list-outside space-y-1 text-white/80 ml-4 text-sm">
                    <li className="font-montserrat pl-2">
                      Pendidikan minimal D3 dari jurusan yang relevan
                    </li>
                    <li className="font-montserrat pl-2">Usia 22-40 tahun</li>
                  </ul>
                </div>
              </div>

              {/* Stock Administrator Mobile */}
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <div
                  className="flex items-center justify-between cursor-pointer hover:bg-white/10 transition-all duration-300 group p-2 rounded-lg -m-2"
                  onClick={() => handleJobClick("/stock-administrator")}
                >
                  <h2 className="font-helvetica tracking-wider text-white font-bold text-lg">
                    2. Stock Administrator
                  </h2>
                  <p className="text-white bg-black px-4 rounded-lg py-2 text-sm  transform group-hover:translate-x-1 transition-transform duration-300">
                    Lamar
                  </p>
                </div>
                <p className="font-montserrat text-white/90 text-justify mt-4 leading-relaxed">
                  Bertanggung jawab untuk mengelola dan memantau inventarisasi
                  gudang, memastikan akurasi stok, mengembangkan SOP warehouse,
                  dan melakukan koordinasi dengan tim terkait untuk menjaga
                  ketersediaan barang serta membuat laporan pergerakan stok
                  secara berkala.
                </p>
                <div className="mt-4">
                  <h3 className="font-helvetica font-semibold text-white mb-2">
                    Kualifikasi:
                  </h3>
                  <ul className="list-disc list-outside space-y-1 text-white/80 ml-4 text-sm">
                    <li className="font-montserrat pl-2">
                      Pendidikan minimal D3 dari jurusan yang relevan
                    </li>
                    <li className="font-montserrat pl-2">Usia 22-40 tahun</li>
                  </ul>
                </div>
              </div>
              {/* SALES PERSON MOBILE */}
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <div
                  className="flex items-center justify-between cursor-pointer hover:bg-white/10 transition-all duration-300 group p-2 rounded-lg -m-2"
                  onClick={() => handleJobClick("/sales-person")}
                >
                  <h2 className="font-helvetica tracking-wider text-white font-bold text-lg">
                    3. Sales Person
                  </h2>
                  <p className="text-white bg-black px-4 rounded-lg py-2 text-sm  transform group-hover:translate-x-1 transition-transform duration-300">
                    Lamar
                  </p>
                </div>
                <p className="font-montserrat text-white/90 text-justify mt-4 leading-relaxed">
                  Bertanggung jawab dalam mencari dan membina hubungan dengan
                  pelanggan baru maupun existing, menawarkan produk sesuai
                  kebutuhan klien, menyusun penawaran, serta memastikan proses
                  penjualan hingga pengiriman berjalan lancar.
                </p>
                <div className="mt-4">
                  <h3 className="font-helvetica font-semibold text-white mb-2">
                    Kualifikasi:
                  </h3>
                  <ul className="list-disc list-outside space-y-1 text-white/80 ml-4 text-sm">
                    <li className="font-montserrat pl-2">
                      Minimal lulusan SMA/SMK/ D3/S1
                    </li>
                    <li className="font-montserrat pl-2">
                      Memiliki SIM A/C dan bersedia melakukan kunjungan lapangan
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Aplikasi;
